import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class OperationParticipantsEffects {



  constructor(private actions$: Actions) {}

}
